export default {
  serviceTestCode: '',
};
